import '../App.css';
import React, { useState, useEffect } from "react";
import { Row, Col, Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import pdf from '../pdfs/god-eaters.pdf'; 
import { Helmet } from 'react-helmet';

function Page() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function renderLinks() {
    return (
      <div style={{lineHeight: isMobile ? '1' : '', fontSize: isMobile ? '15px' : ''}}>
        Source:<br /><br />
		Manuscript held by G. W. Leibniz Bibliothek, Hanover<br />
		Shelfmark LH 1, 2, 3b Bl. 31<br /><br />
		{isMobile ? '' : <hr className="centered-hr" />}
		Date: c. 1677 (?)<br /><br />
        Translated from the French<br /><br /> 
        {isMobile ? '' : <hr className="centered-hr" />}
        <Link to={pdf} target="_blank">View this translation in PDF format (167k)</Link>
      </div>
    );
  }
  
  return (
    <div>
        <Helmet>
            <title>On 'God-Eaters'</title>
            <meta name="description" content="An English translation of ON 'GOD-EATERS' by Gottfried Wilhelm Leibniz, from c. 1677" />
        </Helmet>
        <Routes>
          <Route path="/" element={
            <Container fluid className="Container">
              <Row className="main-content">
                <Col md={3} className={`LeftColumn ${isMobile ? 'mobile' : ''}`}>
                  {isMobile ? (
                    <></>
                  ) : (
                    <>
                    {renderLinks()}<br></br>
                 
                    </>
                  )}
                </Col>
                <Col md={8} className={`RightColumn ${isMobile ? 'mobile' : ''}`}>
                  <h2 id='top' className={`PageTitle ${isMobile ? 'mobile' : ''}`}>LEIBNIZ: ON "GOD-EATERS"</h2>
                  {isMobile ? (
                    <>
                    {renderLinks()}  
                    </>
                  ) : (
                    <>
                    
                    </>
                  )}
                 <br />
                 [<b>LH 1, 2, 3b Bl. 31</b>]<br /><br />
                 Boullaye-Le Gouz, in his <var>Voyages</var>, recounts that he and his companions, who were Christians, were received in a certain place in Anatolia by the Turks with numerous insults and abuses, and among others they added this one as the most atrocious: “God-eaters”.<a name="1" href="#note1"><sup>1</sup></a> It is already reported of Averroes that he said there was no religion more absurd than that of the Christians, who eat their God.<a name="2" href="#note2"><sup>2</sup></a><br />
                <br /><br /><br />
                <hr className='rightcol-hr' />
                <br /><br />
                NOTES:<br /><br />
                <a name="note1" href="#1">1.</a> François de La Boullaye-Le Gouz, <var>Les voyages et observations du sieur de la Boullaye-le-Gouz gentil-homme angevin</var> (Paris: Gervais Clovsier, 1653), 21: “I embarked at Smyrna on a Turkish kaiq, which is a kind of brigantine. I was recommended to the Reis or captain by Monsieur du Puy, the French consul in Italy. On the first day of our departure, we sailed southwest along the coast of Asia. On the second day, following the same course, we landed near a fountain where I would have been affronted if not for the Reis. I had taken out a bottle of wine to cool it in the fountain, but it was forcibly taken from me by some Levantines or Barbary soldiers, along with insults, calling me wicked, infidel, and 'God-eater'.”<br />
                <a name="note2" href="#2">2.</a> Leibniz may be thinking of the story invented by the Jesuit Piotr Skarga, in his <var>Artes duodecim sacramentariorum seu Zwingliocalvinistarum, quibus oppugnant & totidem arma catholicorum quibus propugnant praesentiam corporis D.n. Iesu Christi in Eucharistia</var> (Vilnius: Nicholas Christopher Radziwil, 1582), 317: “The Muslim Averroes scoured the globe, trekked across countries, and came upon various sects, but he claims not to have discovered a more degenerate or even more foolish one than the Christian, because its adherents tear apart with their teeth and devour their own God, whom they honour”. Although Skarga invented the story in order to discredit Calvinist objections to the Eucharist by likening them to the one he put in the mouth of Averroes, it was later used by Calvinists to discredit the Catholic doctrine of transubstantiation, for example by Charles Drelincourt, who embellished the story in his <var>Neuf dialogues contre les missionnaires sur le service des Églises Réformées</var> (Geneva: Samuel Chovet, 1655), 305-306: “we cannot forget the lamentable example of that pagan philosopher who, after having seen the eating of Sacrament that had been adored, said that he had never seen a more foolish or more ridiculous sect than that of the Christians, who adore what they eat. And it was on this subject that the wretched man exclaimed, 'let my soul be with that of the philosophers, seeing that the Christians adore what they eat'”. In a marginal note by the words “that pagan philosopher”, Drelincourt indicates that he is referring to Averroes.<br />
                <br /><br />
                &#169; Lloyd Strickland 2024
                <br></br><br></br>
                </Col>
                <Col md={1}></Col>
              </Row>
              <Row className="footer"><h6>&copy; LLOYD STRICKLAND 2003-{new Date().getFullYear()}</h6></Row>
            </Container>
          } />
        </Routes>
      </div>
  );
}

export default Page;
